
import { defineComponent, inject } from 'vue'
import TextInput from '@/components/shared/TextInput.vue'
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { MiscellaneousService } from '@/services/miscellaneous.service'
import { HandleUserNeedingEmailConfirmationMessage } from '@/@types/messages/HandleUserNeedingEmailConfirmationMessage'
import LockingButton from '@/components/shared/LockingButton.vue'

export default defineComponent({
  name: 'SendEmailConfirmation',
  components: {
    LockingButton,
    TextInput
  },
  props: {
    email: {
      type: String,
      default: ''
    }
  },
  setup() {
    const miscellaneousService = inject(PROVIDER_CONSTANTS.miscellaneousService) as MiscellaneousService
    return {
      miscellaneousService
    }
  },
  data() {
    return {
      emailAddress: this.email,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      showSuccessMessage: false
    }
  },
  computed: {
    formValid(): boolean {
      return this.emailAddress.trim() !== ''
    }
  },
  methods: {
    onEnterPressed(): void {
      if (this.formValid)
        this.sendEmailConfirmation()
    },
    sendEmailConfirmation(): void {
      if (this.loading) return

      this.showErrorMessage = false
      this.errorMessage = ''
      this.loading = true

      const handleUserNeedingEmailConfirmationMessage = new HandleUserNeedingEmailConfirmationMessage(this.emailAddress)
      this.miscellaneousService.handleUserNeedingEmailConfirmation(handleUserNeedingEmailConfirmationMessage).then(() => {
        this.loading = false
        this.showSuccessMessage = true
      }).catch(() => {
        this.loading = false
        this.errorMessage = 'Something went wrong. Please try again.'
        this.showErrorMessage = true
      })
    }
  }
})
